// https://masteringjs.io/axios

// Third party modules;
import axios from 'axios';

// HelpBot modules;
import app from '../app';
import { FLOW } from '../Flow';

const api = {

   config : {
      method : 'GET',
      url    : null,
   }, // config;

   control : (object) => {
      api.config.signal = object.signal;
      return 'control';
   }, // control();

   fetch : async (route, option1, option2) => {

      var response = null;

      try {

         api.config.url = app.host_api + route;

         if (api.log_flag || api.log_all) console.log('api:config=', api.log_json ? JSON.stringify(api.config, null, 3) : api.config);

         response = await axios(api.config);

         if ('blob' === response.config.headers.responseType) {

            try {

               const file = response.headers['content-disposition'].split('filename=')[1].replaceAll('"', '');
               const url  = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               // throw new Error('Cannot add a new value to the enum');
               link.href  = url;
               link.setAttribute('download', file);
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               window.URL.revokeObjectURL(url);
               response = { 
                  data  : response.data,
                  file  : file,
                  flow  : FLOW.GOOD,
               }

            } catch (e) {

               response = { 
                  data : {
                     type : '???',
                     text : e.message
                  }, // data;
                  flow  : FLOW.FAIL,
               }
            }

            response.path = route;
            response.time = null;

         } else if (response.data) {

            response = response.data;

         } else {

            response = {
               data : { 
                  stat  : response.status,
                  type : 'app',
                  text : 'Unrecognized response with status code ' + response.status + '.', 
               }, // data;
               flow : FLOW.FAIL,
               path : route,
               time : null
            } // response;

         }

      } catch (e) {

         var data = {};
         var time = null;

         if (e.response && e.response.data && e.response.data.data) {

            data  = e.response.data.data;
            if (e.response.data.time) time = e.response.data.time;

         } else if (e.response && e.response.data && e.response.data.detail && e.message + ' (%s)') {

            data  = {
               type : '???',
               text : e.message + ' (' + e.code + ').',
               args : e.message + ' (%s)'
            };

         } else if (e.message) {

            data  = {
               type : 'app',
               text : e.message
            };

         } else {

            data  = {
               type : '???',
               text : 'Unkown error.',
            };

         }

         response = {
            data  : data,
            flow  : FLOW.FAIL,
            path  : route,
            stat  : e.response.status,
            time  : time
         }

      }

      if (response.data) {

         api.process_data(response);

      }

      response.good = response.flow === FLOW.GOOD;
      response.fail = response.flow === FLOW.FAIL;
      response.warn = response.flow === FLOW.WARN;

      if (api.log_flag || api.log_all) console.log('api:response=', api.log_json ? JSON.stringify(response, null, 3) : response);

      api.config   = {
         method    : 'GET',
         url       : null
      };

      api.log_flag = api.log_all;

      return response;

   }, // fetch();

   headers : (headers) => {
      api.config.headers = headers;
      api.config.method = 'POST';
      return 'headers';
   }, // headers();

   log : (json) => {
      api.log_flag = true;
      api.log_json = ('boolean' === typeof json) && json
      return 'log';
   }, // log();

   log_all  : false,

   log_flag : false,

   log_json : false,

   post : (data) => {
      api.config.method = 'POST';
      if ('undefined' !== typeof data) api.config.data = data;
      return 'post';
   }, // post();

   process_data : (response) => {
      // To be replaced by application;
   }, // process_data();

   token : (headers) => {
      api.config.headers = { authorization : `bearer ${app.state.access_token}` };
      if ('object' === typeof headers) {
         api.config.headers = Object.assign(api.config.headers, headers);
      }
      api.config.method = 'POST';
      return 'token';
   } // token();

};

export default api;
